import "./bannersizecard.scss";
import {BannerSizeCardItem} from "../../modals/types/bannersizecard";

const BannerSizeCard = ({image,size}:BannerSizeCardItem) => {
    return (
        <div className="Banner-Size-Card">
            <img src={image} alt="" className="img-fluid Banner-Size-Card-Image"/>
            <h3 className="Banner-Size-Card-Text pt-4">{size}</h3>
        </div>
    );
}

export default BannerSizeCard;